import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Manca il testo alternativo per questa immagine',
    noAnswers: 'Nessuna opzione di risposta, clicca per continuare.',
    placeholder: 'Specifichi...',
    pleaseSelect: 'Effettui una selezione...',
    rotateLandscape:
      "Disattiva il blocco dell'orientamento sul telefono e ruotalo in modalità orizzontale per continuare.",
    rotatePortrait: 'Ruota il telefono dalla modalità orizzontale a quella verticale per continuare.',
    ir: {
      selectWebCam: 'Seleziona la webcam (se disponibile) o fai clic su "sfoglia" per caricare dal tuo profilo',
      noWebCam: 'Nessuna webcam rilevata',
      accessCamUpload: 'ACCEDI ALLA FOTOCAMERA/CARICAMENTO',
      browse: 'SFOGLIA',
      uploadPhoto: 'Carica una foto',
      instead: 'invece',
      capture: 'SCATTA',
      somethingWrong: 'Spiacenti, si è verificato un errore. Riprova più tardi',
      couldntRead: 'Spiacenti, non è possibile leggere il codice!',
      couldntProcess: 'Spiacenti, non abbiamo potuto elaborare la tua immagine!',
      moveOn: 'Riprova o invia la tua foto e prosegui',
      tryAgain: 'Riprova',
      dataReceived: 'Dati ricevuti!',
      enterManually: 'Riprova o inserisci i dati manualmente qui di seguito',
      positionQR:
        'Posiziona il codice QR davanti alla tua fotocamera in modo che rientri nella cornice rossa o caricala dal tuo computer.',
      analyzing: "Stiamo analizzando l'immagine, attendi prego",
      submit: 'INVIA',
      startOver: 'Inizia da capo',
      allDone: 'Fatto!',
      cantAnalyze:
        'Attenzione: non è possibile visualizzare questa immagine. Prova a inviarla di nuovo o scegli un formato immagine più generico (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Purtroppo questo formato di file non è supportato. Carica un tipo di immagine supportato (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Nessuna webcam rilevata',
      uploadVideo: 'Carica un video',
      skip: 'Saltare?',
      accessCamUpload: 'ACCEDI ALLA FOTOCAMERA/CARICAMENTO',
      browse: 'SFOGLIA',
      instead: 'invece',
      or: 'o',
      stopRecording: 'Sospendi la registrazione',
      willBeStopped: "La registrazione s'interromperà al quinto minuto.",
      stopOnDone: 'Smetti di registrare quando hai finito!',
      record: 'REGISTRA',
      somethingWrong: 'Spiacenti, si è verificato un errore. Riprova più tardi',
      microphone: 'Microfono',
      camera: 'Telecamera',
      selectMicrophone: 'Seleziona il microfono',
      selectCam: 'Seleziona la fotocamera',
      upload: 'Carica',
      playback: 'PLAYBACK',
      stopPlayback: 'INTERROMPERE',
      submit: 'INVIA',
      startOver: 'Inizia da capo',
      allDone: 'Fatto!',
      alternativeRecordSpan: 'Carica un videoclip dal tuo computer o dispositivo.<br/> In alternativa,  &nbsp;',
      alrenativeRecordHref: 'potrai registrare il video con una webcam.',
      cantAnalyze:
        'Attenzione: non è possibile visualizzare questo video. Prova a inviarlo di nuovo o scegli un formato video più generico (MP4, M4V, WEBPM)',
      wrongFormat:
        'Purtroppo questo formato di file non è supportato. Carica un tipo di video supportato (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'SCEGLI',
      pleaseChoose: 'Seleziona',
      this: 'QUESTO',
      one: 'uno',
      myChoice: 'La mia SCELTA'
    },
    hm: {
      addComment: 'Aggiungi un commento di seguito',
      commentMandatoryPlaceHolder: 'Aggiungi commento obbligatorio… ',
      commentOptionalPlaceHolder: 'Aggiungi commento facoltativo…',
      dragPin: 'Trascina per riposizionare (tieni premuto il pulsante del mouse/tocca per collocare precisamente).',
      removePin: "Trascina all'esterno dell'immaginare per eliminare.",
      editComment: 'Clicca/tocca la puntina per modificare il commento.',
      addPin: "Trascina la puntina fuori dal pannello di seguito e fissala a un punto a tua scelta dell'immagine.",
      addPins: "Trascina le puntine fuori dal pannello di seguito e fissale a un punto a tua scelta dell'immagine.",
      leavePins: (minPoints, maxPoints) =>
        `Per favore, metti almeno ${minPoints}, ma non oltre ${maxPoints} puntine di ogni tipo.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Per favore, metti almeno ${minPoints}, ma non oltre ${maxPoints} puntine.`,
      leavePinsWithOff: maxPoints =>
        `Per favore, metti al massimo ${maxPoints} puntine di ogni tipo o clicca su "Avanti" per saltare.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Per favore, metti al massimo ${maxPoints} puntine o clicca su "Avanti" per saltare.`,
      leavePinWithOff: 'Per favore, metti al massimo 1 puntina di ogni tipo o clicca su "Avanti" per saltare.',
      leavePinPerPageWithOff: 'Per favore, metti al massimo 1 puntina o clicca su "Avanti" per saltare.',
      leaveExactlyPin: 'Per favore, metti 1 puntina di ogni tipo.',
      leaveExactlyPinPerPage: 'Per favore, metti 1 puntina.',
      leaveExactlyPins: maxPoints => `Per favore, metti ${maxPoints} puntine di ogni tipo.`,
      leaveExactlyPinsPerPage: maxPoints => `Per favore, metti ${maxPoints} puntine.`,
      leaveComment: "Digita sotto l'immagine per lasciare un commento.",
      noAnswers: 'Nessuna opzione di risposta, clicca su "Avanti" per proseguire.',
      outOfPins: 'Hai finito le puntine',
      pinsBehavior:
        "Man mano che ti sposti sull'immagine, vedrai aree che verranno evidenziate rilasciando un singolo segnaposto.",
      clustersOnly: 'Potrai posizionare i segnaposto solo in queste aree evidenziate.',
      contentAware: "È possibile rilasciare i segnaposti all'interno o all'esterno delle aree evidenziate."
    },
    mp: {
      expand_note: "Clicca sull'immagine, o passaci sopra con il cursore del mouse, per ingrandirla",
      rb_note: rows => `Seleziona solo 1 risposta per ogni voce${rows ? ' sottostante' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Seleziona tutte le opzioni pertinenti:'
        } else if (min === max) {
          return `Seleziona ${1 !== min ? 'almeno' : 'solo'} ${min} rispost${
            1 !== min ? 'e' : 'a'
          } per ciascun articolo${rows ? ' qui sotto' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Seleziona almeno ${min} rispost${1 !== min ? 'e' : 'a'} ma non più di ${max} per ciascun articolo${
            rows ? ' qui sotto' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Seleziona almeno ${min} rispost${1 !== min ? 'e' : 'a'} per ciascun articolo${
            rows ? ' qui sotto' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Seleziona non più di ${max} rispost${1 !== max ? 'e' : 'a'} per ciascun articolo${
            rows ? ' qui sotto' : ''
          }:`
        } else {
          return 'Selezioni tutte le opzioni pertinenti:'
        }
      }
    },
    sh: {
      note: 'Clicca su un prodotto per ingrandirlo e inseriscilo nel tuo carrello virtuale se lo acquisteresti in negozio',
      amazonNote: 'Clicca su un prodotto per allargare e aggiungere al tuo carrello virtuale.',
      fullCart: 'Il tuo carrello è pieno!',
      qty: 'QUANT.',
      addToCart: 'AGGIUNGI AL CARRELLO',
      deleteFromCart: 'ELIMINA',
      emptyCard: 'Il tuo carrello è vuoto',
      each: 'ogni',
      items: 'elementi',
      total: 'Carrello',
      clearCart: 'Svuota il carrello',
      backToStore: 'Torna al negozio',
      na: 'Nessuno dei precedenti',
      next: 'AVANTI',
      maxCartCountError: max => `Non aggiungere più di ${max} prodotti al tuo carrello`,
      scrollError: `Scorri completamente verso sinistra e a destra per procedere con il sondaggio. `,
      maxSpentError: max => `Non spendere più di ${max}.`,
      maxProductCountError: max => `Aggiungi al carrello una quantità non superiore a ${max} per ogni prodotto.`
    },
    rb: {
      note: 'Selezioni solo 1 voce:'
    },
    vo: {
      note: 'Per favore, guarda il video fino alla fine'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Selezioni ${1 !== min ? 'tutto' : 'solo'} ${min} voc${1 !== min ? 'e' : 'i'}:`
        } else if (min > 0 && max < 5000) {
          return `Selezioni almeno ${min} voc${1 !== min ? 'e' : 'i'} ma non più di ${max}:`
        } else if (5000 === max && min > 0) {
          return `Selezioni almeno ${min} voc${1 !== min ? 'e' : 'i'}:`
        } else if (0 === min && max < 5000) {
          return `Selezioni non più di ${max} voc${1 !== max ? 'e' : 'i'}:`
        } else {
          return 'Selezioni tutte le opzioni pertinenti:'
        }
      }
    },
    oe: {
      na: 'Non applicabile',
      note: (min, max, optional) => {
        if (min === max) {
          return `Digiti ${1 !== min ? 'tutto' : 'esattamente'} ${min} caratteri${optional ? ' (opzionale)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Digiti almeno ${min} caratteri, ma non più di ${max}${optional ? ' (opzionale)' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Digiti almeno ${min} caratteri${optional ? ' (opzionale)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Digiti non più di ${max} caratteri${1 !== min ? 's' : ''}${optional ? ' (opzionale)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Compila i seguenti campi:'
    },
    mx: {
      note: 'Sposta i cursori evidenziati per continuare',
      dragSlider: 'Per rispondere, trascini la selezione a sinistra o a destra.'
    },
    psc: {
      dragLeftRight: 'Per rispondere, trascini la selezione a sinistra o a destra.'
    },
    ps: {
      note: value => `Distribuisca i rimanenti ${value} tra gli articoli elencati di seguito.`,
      allDone: 'Fatto!',
      total: `Totale:`,
      dragSlider: 'Per rispondere, trascini la selezione a sinistra o a destra.'
    },
    cx: {
      note: 'Cominci a digitare la Sua risposta per attivare lo scorrimento automatico oppure effettui la selezione manualmente.'
    },
    ro: {
      note: "Per modificare l'ordine, trascinare in alto o in basso:"
    },
    md: {
      note1:
        "Clicca/tocca l'elemento che costituisce la tua prima scelta<br/>Clicca/tocca di nuovo per annullare la selezione.",
      note2:
        "Ora clicca/tocca l'elemento che costituisce la tua ultima scelta<br/>Clicca/tocca di nuovo per annullare la selezione.",
      note3:
        'Grazie! Prosegui andando alla prossima domanda<br/>o clicca/tocca un elemento non selezionato per ricominciare.'
    },
    aro: {
      note: 'Sceglie una voce per ogni coppia.'
    },
    wd: {
      note: 'Assicurati che ogni valore successivo sia superiore a quello precedente.'
    },
    emd: {
      note: 'Per favore, guarda il video fino alla fine',
      noAnswers: 'Nessuna opzione di risposta, clicca per continuare.',
      start: 'Clicca e tieni premuto per avviare',
      resume: 'Clicca e tieni premuto per riprendere',
      continue: 'Sei pronto! <br /> Clicca su Avanti per continuare',
      continueMobile: 'Sei pronto! <br /> Clicca QUI per continuare',
      training: {
        session: 'sessione di adestramento',
        note: "Concludi l'apprendimento",
        moveLeft: 'Trascina il quadrante completamente a sinistra',
        moveBottom: 'Trascina il quadrante fino al punto più basso',
        moveRight: 'Adesso trascina il quadrante completamente a destra',
        moveTop: 'Adesso trascina il quadrante fino al punto più alto',
        success: 'Ottimo lavoro!'
      }
    },
    sft: {
      noAnswers: 'Nessuna opzione di risposta, clicca per continuare.',
      note: 'Rispondi nel più breve tempo possibile, nel modo che intuitivamente ti sembra corretto',
      finish: 'Hai finito! <br /> Clicca su Avanti per continuare',
      training: {
        start:
          '<p>Questa domanda ti mostrerà diverse parole in rapida sequenza e richiederà concentrazione da parte tua. ' +
          'Per rispondere dovrai reagire velocemente. </p> <p> Sei pronto per esercitarti?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Tocca "{buttonLeft}"`
            : (mouse ? `Clicca "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Premi il tasto "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Tocca "{buttonRight}"`
            : (mouse ? `Clicca "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Premi il tasto "{keyBtnRight}"` : ''),
        fail: () => 'Troppo lento',
        success: () => 'Ottimo!',
        finish: () =>
          '<p><strong> Eccellente!</strong></p><p>Assicurati di non distrarti <br />' +
          'nei prossimi 2-3 minuti. </p><p>Quando sei pronto, clicca su Avanti per iniziare.</p>'
      },
      buttons: {
        start: 'Inizia',
        yesno: {
          left: 'Sì',
          right: 'No'
        },
        matches: {
          left: 'Corrisponde',
          right: 'Non corrisponde'
        },
        fits: {
          left: 'Si adatta',
          right: 'Non si adatta'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
